<template>
    <div id="Faqs">
        <div class="container">
            <div class="row">
              <div class="col-12">
                  <!-- <div v-if="faqs" class="ql-editor"> -->
                    <div v-html="faqs"></div>
                  <!-- </div> -->
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.bubble.css';

export default {
  data(){
    return {
        faqs: ''
    }
  },
  async created() {
    try{
        const { data: { results } }  = await this.$store.$oddjob.settings.getConfigFaqUrl("faq_html");
        if(results && results.length){
            this.faqs = results[0].value;
        }
    }catch(err){
        console.log("API get config ")
    }
  }
}
</script>
<style lang="scss">
#Faqs{
  .ql-editor{
     padding: 0px;
     line-height: 24px;
     font-size: 14px;
  }
  padding: 0px;
  line-height: 24px;
  font-size: 14px;
  .text-black{
    color: black
  }
}
.backgound-gray{
  background: #F7F7F7;
  border-radius: 14px;
  padding: 20px;
  height: 100%;
}
</style>
<style lang="scss" scoped>
</style>